import { ConfirmationWindow } from "@vendor-app/app/_sharedComponents/ConfirmationWindow";
import { UpcomingOrdersTableAccess } from "../../store";
import React, { useCallback, useContext } from "react";
import { bulkUnskipCustomerPurchaseState } from "@vendor-app/app/_state/actionCreators/customerPurchaseState";
import { useSmartrrVendorDispatch } from "@vendor-app/app/_state/typedVendorReduxHooks";
import { UpcomingOrdersBulkActionCompletedContext } from "../Table/UpcomingOrdersBulkActionCompletedContext";
import { useUpcomingOrderUnskipModal } from "./store";

export const UpcomingOrderUnskipModal = () => {
  const selectedResources = UpcomingOrdersTableAccess.useSelectedData();
  const { isModalOpen, closeModal } = useUpcomingOrderUnskipModal();
  const dispatch = useSmartrrVendorDispatch();
  const bulkActionContext = useContext(UpcomingOrdersBulkActionCompletedContext);

  const confirmationCallback = useCallback(async () => {
    const dates = selectedResources.map(order => order.date);

    const purchaseState = selectedResources[0].purchaseState;
    if (purchaseState.id && purchaseState.custRel) {
      await dispatch(
        bulkUnskipCustomerPurchaseState({
          customerPurchaseStateId: purchaseState.id,
          customerRelationshipId: purchaseState.custRel.id,
          dates,
        })
      );
    }
    bulkActionContext.onCompleted();
    closeModal();
  }, [selectedResources, dispatch, closeModal]);

  if (selectedResources.length === 0) {
    return <React.Fragment />;
  }

  return (
    <ConfirmationWindow
      title={`Are you sure you want to unskip ${selectedResources.length} date(s)?`}
      onReject={closeModal}
      onConfirm={confirmationCallback}
      confirmationText="Yes"
      rejectionText="No"
      open={isModalOpen}
    >
      It might take a few minutes to process this request.
    </ConfirmationWindow>
  );
};
